module.exports = "pegasus/assets/theme2/medium/3.jpg";